document.addEventListener("DOMContentLoaded", () => {
  const quickAddButtons = document.querySelectorAll(".custom-quick-add-btn");

  quickAddButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();

      const cardWrapper = button.closest(".custom-card-wrapper");

      if (cardWrapper) {

        if (window.innerWidth > 1024 || window.innerWidth < 768) {
          cardWrapper.classList.remove("quick-add-enabled");
        }
        cardWrapper.classList.add("show-variant-info");

        if (window.innerWidth >= 768) {
          const containerDetails = cardWrapper.querySelector(".custom__container-details");
          if (containerDetails) {
            containerDetails.style.justifyContent = "space-between"; 
          }
        }


        const description = cardWrapper.querySelector(".custom__description");
        if (description) {
          description.style.display = "none";
        }

        button.style.display = "none";

        const hoverVideo = cardWrapper.querySelector(".product-hover-video");
        if (hoverVideo) {
          hoverVideo.style.display = "none";
        }

        const productImage = cardWrapper.querySelector(".custom-product-image");
        if (productImage) {
          productImage.style.opacity = "1";
        }
      }
    });
  });
});
